var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.03125C4.58369 5.03125 2.625 6.98994 2.625 9.40625C2.625 11.8226 4.58369 13.7812 7 13.7812C9.41631 13.7812 11.375 11.8226 11.375 9.40625C11.375 6.98994 9.41631 5.03125 7 5.03125ZM7.21875 10.0428V11.375H6.78125V10.0428C6.16066 9.93847 5.6875 9.40012 5.6875 8.75C5.6875 8.02506 6.27506 7.4375 7 7.4375C7.72494 7.4375 8.3125 8.02506 8.3125 8.75C8.3125 9.40012 7.83934 9.93847 7.21875 10.0428Z",
    fill: "#909599"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59375 5.24125V3.0625C4.59375 1.73578 5.67328 0.65625 7 0.65625C8.32672 0.65625 9.40625 1.73578 9.40625 3.0625H9.84375C9.84375 1.4945 8.568 0.21875 7 0.21875C5.432 0.21875 4.15625 1.4945 4.15625 3.0625V5.52694C4.29647 5.42391 4.44259 5.32875 4.59375 5.24125Z",
    fill: "#909599"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.04a48639.svg";
export { ForwardRef as ReactComponent };